import { Component, OnInit } from '@angular/core';
import { EmitterService } from '../../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-breadcrumb-toggle',
	styleUrls: ['./breadcrumb-toggle.component.css'],
	templateUrl: './breadcrumb-toggle.component.html'
})
export class BreadcrumbToggleComponent implements OnInit {
	public isToggleON = false;

	constructor() {}

	ngOnInit(): void {}

	toggleIcon(): void {
		this.isToggleON = !this.isToggleON;
		EmitterService.get(EVENT_EMITTERS.TOGGLE_LAYOUT).emit(this.isToggleON);
	}
}
